// extracted by mini-css-extract-plugin
module.exports = {"root":"ComposeExternalEmail_root__1eSZm","syncLabel":"ComposeExternalEmail_syncLabel__1nCwr"};